(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/searchbar-section/searchbar-section.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/searchbar-section/searchbar-section.js');
"use strict";

const Searchbar = svs.grassroots.components.searchbar_section.Searchbar;
const {
  grassrootsQueryApi
} = svs.grassroots.store;
const {
  useState,
  useRef
} = React;
const {
  links
} = svs.grassroots;
const {
  useHistory
} = ReactRouterDOM;
const SearchbarSection = _ref => {
  let {
    openBottomSheet
  } = _ref;
  const [displayResults, setDisplayResults] = useState(true);
  const [searchterm, setSearchterm] = useState('');
  const {
    data
  } = grassrootsQueryApi.useFetchReceiversSearchQuery({
    searchterm
  });
  const ref = useRef(null);
  const history = useHistory();

  const fetchReceiversHandler = e => {
    history.push(svs.grassroots.links.query(e.target[0].value));
  };
  const resetSearchField = () => {
    setDisplayResults(false);
    setSearchterm('');
  };
  const onBlurHandler = e => {
    if (!ref.current.contains(e === null || e === void 0 ? void 0 : e.relatedTarget)) {
      resetSearchField();
    }
  };
  const onChangeHandler = e => {
    setSearchterm(e.currentTarget.value);
    setDisplayResults(true);
  };
  const onClickHandler = receiver => {
    openReceiverDetails(receiver);
  };
  const onKeyDownHandler = (event, receiver) => {
    if (event.keyCode === svs.utils.keylistener.KEY_ENTER) {
      openReceiverDetails(receiver);
    }
  };
  const openReceiverDetails = receiver => {
    resetSearchField();
    openBottomSheet(receiver);
    window.history.replaceState(null, null, "".concat(svs.core.data.baseUrl).concat(links.single(receiver.id, receiver.shortname)));
  };
  return React.createElement("div", {
    className: svs.grassroots.background
  }, React.createElement(Searchbar, {
    displayResults: displayResults,
    onBlur: onBlurHandler,
    onChange: onChangeHandler,
    onClick: onClickHandler,
    onKeyDown: onKeyDownHandler,
    onSubmit: fetchReceiversHandler,
    ref: ref,
    searchResult: data === null || data === void 0 ? void 0 : data.receivers,
    searchterm: searchterm
  }));
};
svs.grassroots.components.searchbar_section.SearchbarSection = SearchbarSection;

 })(window);